const {
  parsePath
} = require('@truqc/content-path');

/**
  * @function evalute - evaluate parentPathComponentsBehavior
  */

const evaluate = async (source, content, parentContentPath) => parsePath(parentContentPath);
module.exports = {
  evaluate
};